import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import "./App.css";

const CommandPalette = lazy(() => import("./components/CommandPalette"));

// Lazy load heavy components to improve initial bundle size
const Signin = lazy(() => import("./components/Signin"));
const Home = lazy(() => import("./pages/admin/Home"));
const Tags = lazy(() => import("./pages/admin/Tags"));
const AddTags = lazy(() => import("./pages/admin/AddTags"));
const FrontendTags = lazy(() => import("./pages/frontend/Tags"));
const FrontendMessage = lazy(() => import("./pages/frontend/Message"));
const Signup = lazy(() => import("./pages/Signup"));
const EditNotes = lazy(() => import("./pages/admin/EditNotes"));
const PrivateRoutes = lazy(() => import("./PrivateRoute"));
const AdminRoute = lazy(() => import("./AdminRoute"));
const ForgotPasswod = lazy(() => import("./pages/ForgotPasswod"));
const Setting = lazy(() => import("./pages/admin/Setting"));
const EnhancedAdminConsole = lazy(() => import("./pages/admin/EnhancedAdminConsole"));
const Notification = lazy(() => import("./components/frontend/Notification"));
const NotificationMain = lazy(() => import("./pages/frontend/NotificationMain"));
const MainTemplate = lazy(() => import("./pages/frontend/MainTemplate"));
const CollaborationTest = lazy(() => import("./pages/CollaborationTest"));
const Favorites = lazy(() => import("./pages/Favorites"));
const PublicNote = lazy(() => import("./pages/PublicNote"));

// Loading component
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '18px',
    color: '#666'
  }}>
    Loading...
  </div>
);

function App() {
  return (
    <ErrorBoundary>
    <Suspense fallback={<LoadingSpinner />}>
      <BrowserRouter>
        <CommandPalette />
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route path="/admin" element={<Home />} />

            <Route path="/admin/tags" element={<Tags />} />
            <Route path="/admin/addtags" element={<AddTags />} />

            <Route path="/admin/editnotes/:id" element={<EditNotes />} />
            <Route path="/admin/editnotes/" element={<Home />} />
            <Route path="/notes/:id" element={<EditNotes />} />
            <Route path="/setting" element={<Setting />} />
            <Route path="/tags" element={<FrontendTags />} />
            <Route path="/favorites" element={<Favorites />} />
            {/* <Route path="/template" element={<MainTemplate />} /> */}
            <Route path="/notification" element={<NotificationMain />} />

            {/* <Route path="/tags" element={<FrontendTags />} /> */}
          </Route>
          {/* Admin console (role-gated) */}
          <Route element={<AdminRoute />}>
            <Route path="/console" element={<EnhancedAdminConsole />} />
            <Route path="/console/users" element={<EnhancedAdminConsole />} />
            <Route path="/console/payments" element={<EnhancedAdminConsole />} />
            <Route path="/console/packages" element={<EnhancedAdminConsole />} />
            <Route path="/console/analytics" element={<EnhancedAdminConsole />} />
            <Route path="/console/system" element={<EnhancedAdminConsole />} />
            <Route path="/console/reports" element={<EnhancedAdminConsole />} />
            <Route path="/console/firebase" element={<EnhancedAdminConsole />} />
            <Route path="/console/admins" element={<EnhancedAdminConsole />} />
            <Route path="/console/logs" element={<EnhancedAdminConsole />} />
          </Route>
          <Route path="/" element={<Signin />} />
          <Route path="/collaboration-test" element={<CollaborationTest />} />

          <Route path="/signup" element={<Signup />} />
          {/* Note shared by link: public, read-only, no sign-in */}
          <Route path="/s/:token" element={<PublicNote />} />
          <Route path="/forgotpassword" element={<ForgotPasswod />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
    </ErrorBoundary>
  );
}
export default App;
